type LineItem = {
    variant: {
        id: number;
    };
    minimumMonths: number;
    planId: number;
    quantity: number;
};

type CartItem = LineItem & {
    rentalPlanId: number;
    id: number;
};

type Cart = {
    items?: Array<CartItem>;
    orderNumber?: string;
};

const findExistingItem = ({
    cartItems,
    variantId,
    planId,
}: {
    cartItems: Array<CartItem>;
    variantId: number;
    planId: number;
}): CartItem | undefined => {
    return cartItems.find((cartItem: { rentalPlanId: number; variant: { id: number } }) => {
        if (planId && cartItem.rentalPlanId) {
            return cartItem.variant.id === variantId && cartItem.rentalPlanId === planId;
        }
        return cartItem.variant.id === variantId;
    });
};

export const addItemToCart = ({
    send,
    cart,
    items,
    isDesktopUser,
    callback,
    voucher,
}: {
    send: (arg1: string, arg2: object) => {};
    cart: Cart;
    items: Array<LineItem>;
    isDesktopUser?: boolean;
    callback?: () => void;
    voucher?: string;
}): void => {
    if (!cart.orderNumber) {
        send('CREATE', { items, callback, voucher });
        return;
    }

    if (items.length === 1) {
        const item = items[0];
        const existingItem =
            cart && cart.items
                ? findExistingItem({
                      cartItems: cart.items,
                      variantId: item.variant.id,
                      planId: item.planId,
                  })
                : null;
        if (existingItem) {
            send('UPDATE_LINE_ITEM', {
                item: {
                    id: existingItem.id,
                    quantity: existingItem.quantity + item.quantity,
                },
                callback,
            });
        } else {
            send('ADD_LINE_ITEM', { items, callback });
        }
    } else {
        send('ADD_LINE_ITEM', { items, callback, voucher });
    }

    if (cart.items) {
        send('UPDATE_OVERLAY_STATE', { isOverlayActive: true });

        if (isDesktopUser) {
            setTimeout(() => send('UPDATE_OVERLAY_STATE', { isOverlayActive: false }), 2000);
        }
    }
};
